<template>
  <vk-modal :show.sync="showReorderEditModal">
    <!-- <div style="text-align: center !important;"> -->
    <vk-modal-close @click="closeModal"></vk-modal-close>
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <vk-modal-title>Edit Reorder Level</vk-modal-title>
    </div>
    <hr />
    <div class="d-block text-center">
      <el-form-item class="form-item">
        <el-input
          placeholder="Reorder Level"
          type="number"
          @input="updateInput"
          @change="updateInput"
          v-model="modalValue"
        ></el-input>
      </el-form-item>

      <el-button
        size
        class="btn btn-primary"
        @click="updateReorderLevel"
        style="margin-top: 12px;"
      >Save Changes</el-button>
    </div>
  </vk-modal>
</template>

<script>
/* eslint-disable */
import {
  Button,
  Form,
  FormItem,
  Input
  // ...
} from "element-ui";

import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";

export default {
  name: "EditReorderLevelComponent",
  props: {
    showReorderEditModal: false,
    defaultValue: 0,
    reorderItemRow: {}
  },
  components: {
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-input": Input
  },
  data() {
    return {
      modalValue: 0
    };
  },
  watch: {
    defaultValue: {
      handler(after){
        this.modalValue = after
      },
      immediate: true
    }
  },
  methods: {
    updateInput(){
      this.$emit('modalValue', this.modalValue)
    },
    closeModal() {
      this.$emit("closeModal");
    },
    updateReorderLevel() {
      const HTTP = this.$httpUtils.instance;
      const url = "/component_types";
      const values = {
        ...this.reorderItemRow,
        reorderLevel: this.modalValue
      };

      HTTP.patch(url, values)
        .then(response => {
          // console.log(response)
          this.$emit("updateCallback", true);
        })
        .catch(error => {
          // console.log(error);
          this.$emit("updateCallback", false);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyInventoryComponents/EditReorderLevelComponent.vue